var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentOpenpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "719lpz96ra",
    d: "M0 0.131L4.07 0.131 4.07 4.391 0 4.391z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r3v9u71jrc",
    d: "M0.03 0.201L0.496 0.201 0.496 0.432 0.03 0.432z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lhtawx7mce",
    d: "M0.066 0.201L0.472 0.201 0.472 0.374 0.066 0.374z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5hoac9rtvg",
    d: "M0.08 0.119L4.979 0.119 4.979 5.676 0.08 5.676z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68 -58) translate(68 58)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5,
    height: 21.5,
    x: 0.25,
    y: 0.25,
    fill: "#FFF",
    stroke: "#C7C7C7",
    strokeWidth: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 8) translate(0 .032)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1x26hvywib",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#719lpz96ra"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3B465C",
    d: "M2.461.13c.3.055.33.232.225.475-.014.033-.013.072-.02.108-.1.442-.1.44-.559.477-.273.023-.499.143-.668.356-.274.346-.368.743-.284 1.17.116.588.722.838 1.225.502.433-.29.598-.73.534-1.224-.037-.286.019-.426.31-.481.19-.036.375-.106.556-.176.15-.056.206.005.233.137.294 1.407-.582 2.722-1.913 2.899-.91.12-1.74-.379-2.018-1.246C.058 3.052.08 2.957 0 2.902v-.776C.074 1.283.516.693 1.266.313c.24-.122.494-.154.757-.154.127-.013.259.03.382-.028h.056z",
    mask: "url(#1x26hvywib)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 8) translate(10.54 .032)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "boej1fcjed",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r3v9u71jrc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4C1",
    d: "M.03.274C.032.25.033.226.033.2h.46C.49.227.491.251.496.277.34.458.185.46.03.274",
    mask: "url(#boej1fcjed)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 8) translate(1.946 .032)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a0y4x1wxff",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lhtawx7mce"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A4A8BB",
    d: "M.066.275C.07.251.071.226.07.201h.402C.35.365.202.264.066.275",
    mask: "url(#a0y4x1wxff)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3B465C",
    d: "M5.815.616c.418-.316.84-.43 1.32-.358.618.093 1.037.435 1.185 1.023.218.866.065 1.684-.497 2.403-.605.774-1.887 1-2.695.226-.091.437-.176.857-.266 1.275-.107.495-.646.791-1.128.624-.145-.05-.097-.157-.077-.253.205-.964.412-1.927.618-2.89.146-.685.296-1.368.433-2.055C4.75.4 4.823.277 5.07.316c.136.022.279.01.418.002.2-.012.33.052.327.298M17.562 3.918L17.29 5.19c-.104.483-.672.792-1.13.617-.124-.048-.087-.133-.067-.227.204-.945.404-1.89.605-2.835.158-.738.323-1.475.47-2.215.032-.163.096-.218.256-.21.167.01.336.013.503 0 .207-.014.315.072.326.295.458-.351.95-.454 1.503-.312.555.142.87.499 1.015 1.028.27.986-.165 2.247-.943 2.741-.74.47-1.504.423-2.266-.154M23.594 3.941c-.551.489-1.118.556-1.702.26-.606-.307-.836-.86-.864-1.507-.026-.597.127-1.142.46-1.646.49-.738 1.783-1.23 2.72-.386.007-.33.217-.349.472-.345.686.012.69.005.553.675-.17.829-.35 1.656-.517 2.485-.036.18-.06.366-.052.548.01.228-.087.296-.298.278-.139-.012-.28-.007-.419-.002-.216.009-.367-.054-.353-.36",
    transform: "translate(3 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 8) translate(24.486 .194)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xt39yw0rdh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5hoac9rtvg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3B465C",
    d: "M2.49 2.673c.445-.827.853-1.57 1.245-2.322.09-.172.195-.242.39-.227.212.017.428.009.642.003.218-.007.266.053.151.256-.676 1.196-1.342 2.399-2.013 3.598-.198.354-.375.722-.665 1.017-.528.539-1.146.81-1.913.614-.288-.072-.303-.115-.152-.368.052-.087.11-.17.16-.26.116-.21.202-.381.537-.321.408.073.84-.462.768-.877C1.445 2.67 1.252 1.553 1.04.44.994.19 1.05.1 1.31.125c.184.017.374.02.558-.001.252-.03.31.089.336.31.08.721.182 1.44.286 2.24",
    mask: "url(#xt39yw0rdh)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3B465C",
    d: "M10.57.21l.453.001C12.297.35 12.72 1.443 12.45 2.46c-.043.164-.154.154-.277.154-.754 0-1.508.011-2.262.002-.236-.003-.266.073-.198.275.099.298.283.486.596.553.369.078.697-.007.933-.291.14-.17.245-.181.414-.073.108.07.226.13.348.172.263.092.23.225.092.411-.51.685-1.553.955-2.39.609-.776-.32-1.21-1.135-1.076-2.016.161-1.063.76-1.772 1.693-2.005.08-.02.164-.027.247-.04M14.223.624c.401-.365.84-.463 1.308-.393.671.1 1.068.648.986 1.378-.08.714-.29 1.405-.426 2.11-.004.018-.013.035-.017.053-.12.55-.12.55-.693.527-.363-.015-.506-.19-.432-.543.114-.541.234-1.08.351-1.621.016-.072.027-.145.037-.218.032-.26.015-.504-.258-.642-.238-.121-.564-.068-.779.128-.17.155-.262.354-.31.575-.153.693-.308 1.385-.452 2.079-.036.17-.101.26-.294.246-.194-.015-.392-.015-.587 0-.232.015-.291-.065-.241-.29.222-1.007.427-2.018.648-3.026.152-.695.158-.69.884-.669.185.006.283.067.275.306",
    transform: "translate(3 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B7A6",
    d: "M2.66 1.552c.09-.427.17-.818.254-1.209.021-.1.092-.09.172-.078.349.052.73.425.8.764.026.126-.048.143-.123.171-.112.042-.227.076-.342.113l-.762.24",
    transform: "translate(3 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFE",
    d: "M7.272 2.204c-.017.3-.117.658-.418.93-.267.243-.58.322-.928.2-.336-.119-.453-.401-.476-.717-.028-.388.07-.75.333-1.053.277-.318.671-.425 1.028-.288.307.12.464.405.461.928",
    transform: "translate(3 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFEFE",
    d: "M19.702 2.11c0 .394-.109.747-.406 1.02-.273.252-.597.335-.95.199-.35-.136-.452-.433-.46-.778-.01-.352.078-.673.296-.954.255-.328.673-.458 1.039-.327.336.12.488.385.481.84M22.151 2.357c.02-.344.155-.774.612-1.024.524-.286 1.06.003 1.11.594.03.337-.036.662-.202.96-.219.39-.61.576-1.002.48-.342-.082-.525-.388-.518-1.01",
    transform: "translate(3 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFD",
    d: "M10.62 1.826c-.212 0-.426-.005-.638.002-.138.005-.188-.018-.119-.164.202-.43.747-.659 1.196-.494.117.044.211.117.28.217.078.114.163.256.107.382-.055.122-.214.048-.326.055-.165.01-.333.002-.5.002",
    transform: "translate(3 8)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentOpenpay);
export default __webpack_public_path__ + "static/media/payment-openpay.2f3e5512301db380872624e81ff44107.svg";
export { ForwardRef as ReactComponent };